import React from "react";
import axiosClient from "config/axios";

/***
 * Dataservices to show the dependents with the "get" method
 */
export const getDependents = async (data) => {
  let result = {};
  await axiosClient
    .get("/user_management/dependant/", data)
    .then((response) => {
      result = {
        error: false,
        result: response.data,
      };
    })
    .catch((error) => {
      result = {
        error: true,
        message: "auth__server_error",
        result: error.response.data,
      };
    });
  return result;
};
